import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CategoryModel } from 'src/app/models/general/category.model';
import { LocalStorageManager } from 'src/app/utils/local-storage-manager/local-storage-manager.utils';

@Component({
  selector: 'app-selector-multi-categories',
  templateUrl: './selector-multi-categories.component.html',
  styleUrls: ['./selector-multi-categories.component.css']
})
export class SelectorMultiCategoriesComponent implements OnInit, OnChanges {
  @Input() categories : CategoryModel[] = [];
  @Input() selectedCategoriesPks : number[] = [];
  @Input() showSelectAll : boolean = true;
  @Input() showShared : boolean = true;
  @Input() limit : number = 0;
  @Output() emitter = new EventEmitter<CategoryModel[]>();
  ls = LocalStorageManager;
  isDarkMode = LocalStorageManager.isDarkmode;
  selectAll : boolean = false;
  textColor: string = "";
  backgroundColor: string = ""
  categoriesNames: string = ""
  pressTimer: any;
  isLongPress = false;
  disableList = false;

  constructor( private translate: TranslateService) {
    this.translate.use(this.ls.lang!);
  }

  ngOnInit(): void {
    this.categories.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    this.selectAll = this.limit == 5;
    this.selectedAllCategories();
  }

  ngOnChanges(): void {
    this.categories.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    this.setColors();
  }

  //MARK: PUBLIC METHODS ----------------------------------------------------------------
  public onPressStart(category: CategoryModel) {
    if (this.disableList && !category.selected) { return }
    this.isLongPress = false;
    this.pressTimer = setTimeout(() => {
      this.isLongPress = true;
      this.onLongPress(category);
    }, 1000);
  }

  public onPressEnd(category: CategoryModel) {
    clearTimeout(this.pressTimer);
    if (this.disableList && !category.selected && !this.isLongPress) { return }
    this.setCategory(category);
  }

  public selectedAllCategories() {
    this.selectAll = !this.selectAll
    if (!this.selectAll) { return }
    this.categories.forEach(row => row.selected = true);
    this.selectedCategoriesPks = this.categories.filter(row => row.selected).map(row => row.pkCategory);
    this.emitCategories()
  }

  //MARK: PRIVATE METHODS ---------------------------------------------------------------
  private onLongPress(category: CategoryModel) {
    this.setCategory(category);
  }

  private setCategory(category: CategoryModel) {
    if (this.isLongPress) {
      this.categories.forEach(row => row.selected = false);
      category.selected = true
    } else {
      category.selected = !category.selected;
    }
    this.selectedCategoriesPks = this.categories.filter(row => row.selected).map(row => row.pkCategory);
    this.selectAll = this.selectedCategoriesPks.length == this.categories.length
    this.disableList = (this.limit == this.selectedCategoriesPks.length);
    if (this.selectedCategoriesPks.length == 0) {
      this.selectedAllCategories();
    }
    this.setNameCategories();
    this.emitCategories();
  }

  private setNameCategories() {
    this.categoriesNames = "";
    this.categories.forEach(row => {
      if (row.selected)  {
        this.categoriesNames = `${this.categoriesNames}, ${row.name}`;
      }
    });
    if (this.categoriesNames.startsWith(',')) {
      this.categoriesNames = this.categoriesNames.substring(2);
    }
  }

  private setColors(){
    this.textColor = this.isDarkMode ? "#FFF" : "#000";
    this.backgroundColor = this.isDarkMode? "#343A40" : "#FFFFFF";
  }

  private emitCategories() {
    this.emitter.emit(this.categories.filter(row => row.selected))
  }
}
